import { apiCall } from "../../services/api-service";

// Generic API request handler
export const fetchData = async (endpoint, errorContext = "data") => {
  try {
    const response = await apiCall("GET", endpoint);
    return response.data;
  } catch (err) {
    console.error(`Error fetching ${errorContext}:`, err);
    throw err;
  }
};
